"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));

function compose() {
  var wrappingFunctions = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    wrappingFunctions[_i] = arguments[_i];
  }

  return function wrapComponent(OriginalComponent) {
    var result;

    if (wrappingFunctions.length === 0) {
      result = OriginalComponent;
    } else {
      result = wrappingFunctions.reduce(function (wrappingFunctionA, wrappingFunctionB) {
        return function (WrappingComponent) {
          return wrappingFunctionA(wrappingFunctionB(WrappingComponent));
        };
      })(OriginalComponent);
    }

    return hoist_non_react_statics_1.default(result, OriginalComponent);
  };
}

exports.default = compose;